import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold font-size-24 mb-8" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_7 = { class: "text-red-ed font-size-14" }
const _hoisted_8 = { class: "mb-1 text-red-ed font-size-14" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_14 = { class: "font-bold mb-4 font-size-18" }
const _hoisted_15 = { class: "mb-4 w-2/5" }
const _hoisted_16 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_17 = { class: "mb-4 w-2/5" }
const _hoisted_18 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_19 = { class: "mb-4 w-2/5" }
const _hoisted_20 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_21 = { class: "ml-8" }
const _hoisted_22 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_23 = { class: "font-size-14 text-red-ed" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_26 = { class: "w-2/5" }
const _hoisted_27 = { class: "ml-8" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = { class: "font-size-14 text-red-ed" }
const _hoisted_34 = { class: "font-size-14 font-bold mb-1" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "mt-3" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_39 = { class: "w-2/5" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_42 = { class: "w-2/5" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_45 = { class: "w-2/5" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_48 = { class: "flex" }
const _hoisted_49 = { class: "mr-2 mt-3" }
const _hoisted_50 = { class: "mt-3" }
const _hoisted_51 = { class: "mb-4" }
const _hoisted_52 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = { class: "mt-3" }
const _hoisted_55 = { class: "mb-8" }
const _hoisted_56 = { class: "font-size-18 font-bold mb-4" }
const _hoisted_57 = { class: "mb-4" }
const _hoisted_58 = { class: "mb-4" }
const _hoisted_59 = { class: "flex" }
const _hoisted_60 = { class: "mt-3 mr-2" }
const _hoisted_61 = { class: "mr-2 mt-3" }
const _hoisted_62 = { class: "mt-3" }
const _hoisted_63 = { class: "flex" }
const _hoisted_64 = { class: "hover:opacity-75 text-light-blue cursor-pointer" }
const _hoisted_65 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus" }, null, -1)
const _hoisted_66 = { class: "mb-4" }
const _hoisted_67 = { class: "m-4 flex" }
const _hoisted_68 = { class: "mr-2 mt-3" }
const _hoisted_69 = /*#__PURE__*/_createVNode("span", { class: "mr-2 mt-3" }, "～", -1)
const _hoisted_70 = { class: "mr-2 mt-3" }
const _hoisted_71 = { class: "mr-2 mt-3" }
const _hoisted_72 = { class: "mr-2 mt-3" }
const _hoisted_73 = { class: "mr-2 mt-3" }
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = { class: "hover:opacity-75 text-light-blue cursor-pointer" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus" }, null, -1)
const _hoisted_77 = { class: "mb-8" }
const _hoisted_78 = { class: "font-bold font-size-18 mb-4" }
const _hoisted_79 = { class: "flex mb-4" }
const _hoisted_80 = { class: "mt-3" }
const _hoisted_81 = { class: "flex mb-4" }
const _hoisted_82 = { class: "mt-3" }
const _hoisted_83 = { class: "mb-8" }
const _hoisted_84 = { class: "font-bold font-size-18 mb-4" }
const _hoisted_85 = { class: "mb-1" }
const _hoisted_86 = { class: "mb-8" }
const _hoisted_87 = { class: "font-bold font-size-18 mb-4" }
const _hoisted_88 = { class: "flex items-center" }
const _hoisted_89 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Input = _resolveComponent("Input")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_RadioInputGroup = _resolveComponent("RadioInputGroup")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backYearPaidHolidayList }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('vacationMaster')) + " : " + _toDisplayString(_ctx.yearPaidHolidayId ? _ctx.t('edit') : _ctx.t('signUp')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('basicSettings')), 1),
      _hoisted_4,
      _createVNode(_component_Input, {
        class: "w-2/5 mb-4",
        label: _ctx.t('vacationCode'),
        modelValue: _ctx.yearPaidHolidayParams.vacation_code,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.yearPaidHolidayParams.vacation_code = $event))
      }, null, 8, ["label", "modelValue"]),
      _createVNode(_component_Input, {
        class: "w-2/5 mb-4",
        label: _ctx.t('vacationName'),
        modelValue: _ctx.yearPaidHolidayParams.vacation_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.yearPaidHolidayParams.vacation_name = $event))
      }, null, 8, ["label", "modelValue"]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('abbreviation')), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('set10FullWidthCharacters')), 1),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('setNameNotOverlap')), 1),
        _createVNode(_component_Input, {
          class: "w-2/5",
          modelValue: _ctx.yearPaidHolidayParams.abbreviation,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.yearPaidHolidayParams.abbreviation = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('vacationType')), 1),
        _createVNode(_component_Dropdown, {
          class: "w-2/5",
          "options-select": _ctx.yearPaidHolidayTypeList,
          modelValue: _ctx.yearPaidHolidayParams.vacation_type,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.yearPaidHolidayParams.vacation_type = $event))
        }, null, 8, ["options-select", "modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('advancedSetting')), 1),
      _hoisted_13,
      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('annualPaidLeaveSetting')), 1),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('paidCalculationStandard')) + " : " + _toDisplayString(_ctx.t('additionToTheNumberWorkingDays')), 1),
        _createVNode(_component_RadioGroup, {
          "options-radio": _ctx.additionWorkDayList,
          modelValue: _ctx.yearPaidHolidayParams.addition_work_day,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.yearPaidHolidayParams.addition_work_day = $event))
        }, null, 8, ["options-radio", "modelValue"])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('handlingOfPaidDeemedTime')), 1),
        _createVNode(_component_RadioGroup, {
          "options-radio": _ctx.deemedTimeList,
          modelValue: _ctx.yearPaidHolidayParams.deemed_time,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.yearPaidHolidayParams.deemed_time = $event))
        }, null, 8, ["options-radio", "modelValue"])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('takingHalfDayLeave')), 1),
        _createVNode(_component_RadioGroup, {
          class: "mb-4",
          "options-radio": _ctx.takingHalfDayLeaveList,
          modelValue: _ctx.yearPaidHolidayParams.taking_half_day_leave,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.yearPaidHolidayParams.taking_half_day_leave = $event))
        }, null, 8, ["options-radio", "modelValue"]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('halfDayAcquisitionTimeSetting')), 1),
          _createVNode(_component_RadioInputGroup, {
            vertical: "",
            "options-radio": _ctx.halfDayAcquisitionTimeSettingList,
            modelValue: _ctx.yearPaidHolidayParams.half_day_acquisition_time_setting,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.yearPaidHolidayParams.half_day_acquisition_time_setting = $event))
          }, null, 8, ["options-radio", "modelValue"]),
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.t('contractWorkingHoursStaffMaster')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.t('takeHourlyVacation')), 1),
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_RadioGroup, {
            class: "mb-4",
            "options-radio": _ctx.takeHourlyVacationList,
            modelValue: _ctx.yearPaidHolidayParams.take_hourly_vacation,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.yearPaidHolidayParams.take_hourly_vacation = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, _toDisplayString(_ctx.t('maximumNumberOfHoursForAcquisition')), 1),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_RadioInputGroup, {
                vertical: "",
                "options-radio": _ctx.maximumNumberOfHoursForAcquisitionList,
                modelValue: _ctx.yearPaidHolidayParams.maximum_number_hours,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.yearPaidHolidayParams.maximum_number_hours = $event))
              }, null, 8, ["options-radio", "modelValue"]),
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_Input, { class: "mr-4 w-20" }),
                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.t('allowAcquisitionByTime')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('pleaseSetMaximumNumberOfHours')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_34, _toDisplayString(_ctx.t('maximumNumberOfDaysForPaidHourlyLeave')), 1),
            _createVNode("div", _hoisted_35, [
              _createVNode(_component_Input, {
                class: "w-20 mr-2",
                modelValue: _ctx.yearPaidHolidayParams.maximum_number_hours,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.yearPaidHolidayParams.maximum_number_hours = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("span", _hoisted_36, _toDisplayString(_ctx.t('day')), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _createVNode("div", _hoisted_38, _toDisplayString(_ctx.t('takeVacationDuringTheTrialPeriod')), 1),
        _createVNode("div", _hoisted_39, [
          _createVNode(_component_RadioGroup, {
            class: "mb-4",
            "options-radio": _ctx.takeVacationDuringTheTrialPeriodList,
            modelValue: _ctx.yearPaidHolidayParams.take_vacation_during_period,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.yearPaidHolidayParams.take_vacation_during_period = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_40, [
        _createVNode("div", _hoisted_41, _toDisplayString(_ctx.t('additionType')), 1),
        _createVNode("div", _hoisted_42, [
          _createVNode(_component_RadioGroup, {
            class: "mb-4",
            "options-radio": _ctx.additionTypeList,
            modelValue: _ctx.yearPaidHolidayParams.addition_type,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.yearPaidHolidayParams.addition_type = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_43, [
        _createVNode("div", _hoisted_44, _toDisplayString(_ctx.t('automaticPaidManagement')), 1),
        _createVNode("div", _hoisted_45, [
          _createVNode(_component_RadioGroup, {
            class: "mb-4",
            "options-radio": _ctx.automaticPaidManagementList,
            modelValue: _ctx.yearPaidHolidayParams.automatic_paid_management,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.yearPaidHolidayParams.automatic_paid_management = $event))
          }, null, 8, ["options-radio", "modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode("div", _hoisted_47, _toDisplayString(_ctx.t('validityPeriod')), 1),
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, _toDisplayString(_ctx.t('fromTheDateOfGrant')), 1),
          _createVNode(_component_Input, {
            class: "mr-2 w-20",
            modelValue: _ctx.yearPaidHolidayParams.validity_period,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.yearPaidHolidayParams.validity_period = $event))
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_50, _toDisplayString(_ctx.t('validForTheYear')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_51, [
        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.t('maximumHoldingDays')), 1),
        _createVNode("div", _hoisted_53, [
          _createVNode(_component_Input, {
            class: "mr-2 w-20",
            modelValue: _ctx.yearPaidHolidayParams.maximum_holding_days,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.yearPaidHolidayParams.maximum_holding_days = $event))
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_54, _toDisplayString(_ctx.t('day')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_55, [
      _createVNode("div", _hoisted_56, _toDisplayString(_ctx.t('initialGrantDays')), 1),
      _createVNode("div", _hoisted_57, [
        _createVNode("div", _hoisted_58, [
          _createVNode(_component_RadioInput, {
            label: _ctx.t('setTheInitialGrantInALumpSumAccordingOfMonth'),
            value: _ctx.GRANT_SUM_ACCORDING_TYPE.BY_MONTH,
            modelValue: _ctx.yearPaidHolidayParams.grant_sum_according,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.yearPaidHolidayParams.grant_sum_according = $event))
          }, null, 8, ["label", "value", "modelValue"])
        ]),
        _createVNode("div", _hoisted_59, [
          _createVNode("div", _hoisted_60, _toDisplayString(_ctx.t('fromThePaidStartDate')), 1),
          _createVNode(_component_Dropdown, { class: "w-30 mr-2" }),
          _createVNode("div", _hoisted_61, _toDisplayString(_ctx.t('and')), 1),
          _createVNode(_component_Dropdown, { class: "w-30 mr-8" }),
          _createVNode(_component_Input, { class: "w-20 mr-2" }),
          _createVNode("div", _hoisted_62, _toDisplayString(_ctx.t('grantDay')), 1)
        ]),
        _createVNode("div", _hoisted_63, [
          _createVNode("span", _hoisted_64, [
            _hoisted_65,
            _createTextVNode(_toDisplayString(_ctx.t('addAction')), 1)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_66, [
          _createVNode(_component_RadioInput, {
            label: _ctx.t('setTheInitialGrantInALumpSumAccordingForEach'),
            value: _ctx.GRANT_SUM_ACCORDING_TYPE.FOR_EACH,
            modelValue: _ctx.yearPaidHolidayParams.grant_sum_according,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.yearPaidHolidayParams.grant_sum_according = $event))
          }, null, 8, ["label", "value", "modelValue"])
        ]),
        _createVNode("div", _hoisted_67, [
          _createVNode("div", _hoisted_68, _toDisplayString(_ctx.t('thePaidStartDateIs')), 1),
          _createVNode(_component_Input, { class: "mr-2 w-24" }),
          _hoisted_69,
          _createVNode(_component_Input, { class: "mr-2 w-24" }),
          _createVNode("div", _hoisted_70, _toDisplayString(_ctx.t('inTheCaseOf')), 1),
          _createVNode(_component_Dropdown, { class: "mr-2 w-24" }),
          _createVNode("div", _hoisted_71, _toDisplayString(_ctx.t('from')), 1),
          _createVNode(_component_Dropdown, { class: "mr-2 w-24" }),
          _createVNode("div", _hoisted_72, _toDisplayString(_ctx.t('to')), 1),
          _createVNode(_component_Input, { class: "mr-2 w-24" }),
          _createVNode("div", _hoisted_73, _toDisplayString(_ctx.t('grantDay')), 1)
        ]),
        _createVNode("div", _hoisted_74, [
          _createVNode("span", _hoisted_75, [
            _hoisted_76,
            _createTextVNode(_toDisplayString(_ctx.t('addAction')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_77, [
      _createVNode("div", _hoisted_78, _toDisplayString(_ctx.t('numberOfDaysGrantedFromTheNextTimeOnwards')), 1),
      _createVNode("div", _hoisted_79, [
        _createVNode(_component_RadioInput, {
          modelValue: _ctx.yearPaidHolidayParams.grant_from_the_next_time,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.yearPaidHolidayParams.grant_from_the_next_time = $event)),
          value: _ctx.DAY_OF_GRANTED_FROM_THE_NEXT.FIRST_GRAND_DATE,
          class: "mr-2",
          label: _ctx.t('grantFromTheNextTimeOnwardsFromTheFirstGrantDate')
        }, null, 8, ["modelValue", "value", "label"]),
        _createVNode(_component_Dropdown, { class: "mr-2 w-40" }),
        _createVNode("div", _hoisted_80, _toDisplayString(_ctx.t('giveTo')), 1)
      ]),
      _createVNode("div", _hoisted_81, [
        _createVNode(_component_RadioInput, {
          modelValue: _ctx.yearPaidHolidayParams.grant_from_the_next_time,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.yearPaidHolidayParams.grant_from_the_next_time = $event)),
          value: _ctx.DAY_OF_GRANTED_FROM_THE_NEXT.EVERY_YEAR,
          class: "mr-2",
          label: _ctx.t('grantedEveryYearFromTheNextTime')
        }, null, 8, ["modelValue", "value", "label"]),
        _createVNode(_component_DatePickerInput, { class: "mr-2 w-40" }),
        _createVNode("div", _hoisted_82, _toDisplayString(_ctx.t('giveTo')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_83, [
      _createVNode("div", _hoisted_84, _toDisplayString(_ctx.t('withHolidayPayAndDaysTable')), 1),
      _createVNode("div", _hoisted_85, _toDisplayString(_ctx.t('withHolidayPaymentAndCalculationMethodOfDays')), 1),
      _createVNode(_component_Dropdown, {
        class: "w-1/5 mb-4",
        "options-select": _ctx.withHolidayPayAndDayTypeList
      }, null, 8, ["options-select"]),
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.withHolidayPayAndDayHeaders,
        data: _ctx.withHolidayPayAndDayData
      }, null, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_86, [
      _createVNode("div", _hoisted_87, _toDisplayString(_ctx.t('colorSettings')), 1),
      _createVNode("div", _hoisted_88, [
        _createVNode("div", _hoisted_89, _toDisplayString(_ctx.t('displayImage')) + ":", 1),
        _createVNode(_component_Button, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('annualPaid')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_Button, {
        onClick: _ctx.submitRegisterOrUpdateYearPaidHoliday,
        disabled: _ctx.isDisableSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}